import { render, staticRenderFns } from "./StreamItemPlay.vue?vue&type=template&id=4dd10b86&"
import script from "./StreamItemPlay.vue?vue&type=script&lang=js&"
export * from "./StreamItemPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports